import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function ProofSection() {
  return <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto" data-id="element-155">
      <FadeIn data-id="element-156">
        <div className="bg-gradient-to-br from-blush/50 to-white p-8 md:p-12 rounded-3xl shadow-sm border border-rose-gold/20 text-center relative overflow-hidden" data-id="element-157">
          <div className="flex justify-center space-x-2 mb-8" data-id="element-158">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-copper fill-copper" data-id="element-159" />)}
          </div>

          <p className="text-xl md:text-2xl font-serif italic text-warm-dark leading-relaxed mb-8" data-id="element-160">
            "En los primeros 7 días de aplicar este protocolo, la mayoría de las
            mujeres reportan una disminución del 40% en la intensidad de los
            sofocos nocturnos y una sensación de 'ligereza mental' que no
            sentían hace años."
          </p>

          <div className="inline-block bg-white px-6 py-3 rounded-full shadow-sm border border-blush" data-id="element-161">
            <p className="text-rose-gold font-sans font-bold uppercase tracking-wide text-sm" data-id="element-162">
              No es magia, es darle a tu bioquímica exactamente lo que dejó de
              producir.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}